import { Component } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '.../../environments/environment'
import { AuthService } from '../../../_services/index'
import { LoaderService } from 'app/_services/loader.service'
import { process, State } from '@progress/kendo-data-query'
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query'
import {
  GridDataResult,
  DataStateChangeEvent,
} from '@progress/kendo-angular-grid'
import { Observable } from 'rxjs/Observable'
import { ExcelExportData } from '@progress/kendo-angular-excel-export'
import { utils, write, WorkBook } from 'xlsx'
import { saveAs } from 'file-saver'
import { Router } from '@angular/router'
// import Swal from 'sweetalert2';
import 'firebase/firestore'

import * as _moment from 'moment'
import * as _rollupMoment from 'moment'

const moment = _rollupMoment || _moment
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

import {
  AngularFirestore,
  AngularFirestoreDocument,
} from 'angularfire2/firestore'

import { VehMaintenanceService } from './vehMaintenance.service'
import { MaintVehicle } from './vehMaintenance.model'
import { escapeSelector } from 'jquery'
import { truncate } from 'lodash'

declare var $: any
const distinctStatus = (data) =>
  data.filter(
    (x, idx, xs) =>
      xs.findIndex((y) => y.maintenanceStatus === x.maintenanceStatus) === idx,
  )
const distinctCat = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.vehcatname === x.vehcatname) === idx,
  )
const distinctType = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.vehTypName === x.vehTypName) === idx,
  )
const distinctIMEI = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.VTSSTATUS === x.VTSSTATUS) === idx,
  )
const distinctStage = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.STAGENAME === x.STAGENAME) === idx,
  )

@Component({
  selector: 'maintenance-veh',
  templateUrl: './vehicleMaintenance.component.html',
  styleUrls: ['./vehicleMaintenance.component.css'],
})
export class VehicleMaintenanceComponent {
  public prjId: any
  public vehMaintenanceList: any
  public userId: any
  public maintenanceStatus: any
  public maintStatusModal: any
  public maintStatusId: any
  public maintenanceDate: any
  public remarkeModal: any
  public vehId: any
  public isChangestate = true
  public showLoader: boolean
  public partsAreNotAssigned: boolean = false
  public partsAreAssigned: boolean = true
  public maintenanceCount: any
  public success = false
  public error = false
  public totalCount: any
  public runningCount: any
  public serviceCount: any
  public maintDoneCount: any
  public imeiNo: any
  public statusModal: any
  public vehType: any
  public vtsMobile: any
  public maintStatus: any
  public currImeiNo: any
  public parkLoc: any
  public chasisNo: any
  public vtsStatus: any
  public simNo: any
  public dataStatus: any
  public statusDate: any
  public mentStageList: any
  public stageModel: any
  public stageId: any
  public statusIsRequired = false
  public stageIsRequired = false
  isReported = true
  public maintStatusCheck: any
  public underService: any
  public serviceDone: any
  public reported: any
  public accepted: any
  public progress: any
  public completed: any
  public standByCount: any
  vehicleInfo: any
  mntVehId: any

  public isChecked1: boolean
  public isChecked2: boolean
  public isChecked3: boolean

  newLogarray: any
  public total: number = 80
  public state: State = {
    skip: 0,
    take: 50,
    filter: {
      logic: 'and',
      filters: [],
    },
  }
  vehMaintMasterList: any
  maintMstDataNotFound = false
  categoryId: any
  public statusChsnged: boolean

  public date = moment()

  subCategoryList: any
  partTypeList: any
  categoryList: any
  vehiclesTypeList: any
  vehMaintUOMList: any
  vehiclesCatogeryList: any
  quantityModal: any
  categoryModal: any
  subCategoryModal: any
  typeModal: any
  uomModal: any
  priceModal: any
  respMsg: any
  newPartCode: any
  saveSuccess: boolean
  errorInSuccess: boolean
  getQuantity: Object
  partModal: any
  partNameList: any
  loading: boolean
  percentage: number
  downloadURL: any
  backgroundImage: any
  vehNo: any
  driverModal: any
  vehNumModel: any
  fbVtsStatus: any
  fbStatusID: any
  fbVehID: any
  reportedDate: any
  pushID: any
  firebaseData: any

  // breadkdown variables
  fbVehNo: any
  fbIMEI: any
  fbChasis: any
  fbPrjID: any
  fbVehTyp: any
  fbVehCat: any
  fbVTSStatus: any
  fbVTSStatusLive: string
  brkdnObj: any
  fbVehNum: any
  pushIDVehStatus: any
  firebaseDataVehStatus: any
  wipVehNo: any
  vehMaintDocVehStatus: AngularFirestoreDocument<MaintVehicle>
  pushIDWIP: string
  pushIDVehStatusWIP: string
  completeVehNo: any
  statusDated: any
  syncing: boolean
  loaderClass: string
  currentStatus: any
  currentStage: any
  actionrequired: any
  observation: any
  repaireQuotation: any
  BDPartNumber: any
  BDQuantity: any
  BDpartRate: any
  totalAmount: any
  isVendorOrMechanic: number
  partList: any
  partQuantity: any
  partArrayNew: { partId: any; quantity: any }
  reason: any
  place: any
  reportingPerson: any
  observe: string
  action: string
  name: string
  qty: string
  number: string
  partsArray: any
  fbVehTempNo: any
  mecName: any
  mecMobile: any
  mechanicName: string
  mechanicMob: string
  partID: any
  partName: any
  avlblQty: any
  unitPrice: any
  sumVal: any
  sumValOnComplete: any
  RepairCostRemarks: any
  reportDate: any
  extraCost: any
  cost: number
  remarks: string
  totalSum: any
  extraCostView: 0
  filteredPartArray: any
  wipDate: string
  totalSumAmount: number
  userName: string
  userMob: string

  actualQTY: any
  hasRightQty: boolean = true
  wrongQty: boolean = false
  hasBiggerQty: boolean
  vehCurrentStatus: any
  currentStageID: any
  currentStatusID: any
  vehCurrentStatusID: any
  vehCurrentStageID: any
  uniqueID: string
  logData: Object
  logArray: any
  driver_name: string
  workShopvalue: any
  currStatus: any
  currStage: any
  statusName: string
  newStatusID: number
  putOnStandby_by: any
  putOnRunning_by: string

  // standby veh
  standbyVeh: any
  subVehNo: any
  subVehID: any
  noSubVeh: boolean = false
  successMsg: any
  isSubstitute: any

  workShopname = [
    { ID: 1, NAME: 'In House WorkShop' },
    { ID: 2, NAME: 'Vendor WorkShop' },
  ]
  vehCurrentStageName: any
  EngineOilCheck: boolean
  isChecked: any
  checkedIDs: any[]
  selectedItemsList: any
  ReceivedOil: any
  IssuedOil: any
  partname: any
  ReceivedOilErrmsg: boolean
  IssuedOilErrmsg: boolean
  refid: any
  AvailableDieselAttimeOfEngWork: any
  AvailableDieselAttimeOfEngWorkErrMSG: boolean
  AvailableDieselAtExit: any
  AvailableDieselAtExiterrMsg: boolean
  drumIdList: any
  drumIdvalue: any
  compairqty: any
  compairqtyErrMsg: boolean
  drumIdvalueerrmsg: boolean
  values: any
  json_part_array: any
  vehTypeCheck: boolean
  maintenStatusid: any
  isChecked1error: boolean
  approvalsuccessMsg: any
  approvalsuccessMsgcheck: boolean
  checkliststatus: any
  stopsValue: any
  isVtsData: boolean
  IMEI: any
  buttonDisable: boolean
  tempStatus: any
  JobCardNumber: any
  IssueSlipNumber: any

  /*
     * Get all excel data 

    */
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.vehMaintenanceList,
    }
    return result
  }
  public distinctStatus: any[]
  public distinctCat: any[]
  public distinctType: any[]
  public distinctIMEI: any[]
  public distinctStage: any[]
  public groups: GroupDescriptor[] = []
  public view: Observable<GridDataResult>
  public gridView: DataResult
  public items: Observable<any[]>

  options = {
    componentRestrictions: {
      country: ['IN'],
    },
  }

  maintItems: Observable<MaintVehicle[]>
  vehMaintDoc: AngularFirestoreDocument<MaintVehicle>

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups
    this.loadProducts()
  }

  private loadProducts(): void {
    this.gridDataVehList = process(this.vehMaintenanceList, {
      group: this.groups,
    })
  }
  public gridDataVehList: GridDataResult

  VehClass: MaintVehicle = {
    Status: 'BREAKDOWN',
    CurrStatus: null,
    refid: '',
    subVehNo: '',
    subVehID: null,
    pushid: '',
    VTSStatus: '',
    accepted_date: '',
    actionrequired: '',
    driver_name: '',
    workShopvalue: '',
    chasis: '',
    chasisNo: '',
    complaint_id: '',
    complaint: '',
    completed_date: '',
    download_url: '',
    extraCost: '',
    imei: '',
    isMechanics: '',
    isSave: null,
    isVendor: '',
    is_minor_issue: '',
    json_part_array: '',
    lastPingTime: '',
    // location: this.location,
    mobile: '',
    name: '',
    observation: '',
    part_name: '',
    part_number: '',
    prjid: '',
    push_id: '',
    qty: '',
    quotaion_require: '',
    rate: '',
    RepairCostRemarks: '',
    reported_Date: '',
    reportedby: '',
    request_status: '',
    stage: 'REPORTED',
    stageID: '',
    statusDate: '',
    statusId: '',
    tab_position: '',
    total_amount: '',
    typeofuser: '',
    userid: '',
    usermobile: '',
    vehCatName: '',
    vehId: '',
    vehTempNo: '',
    vehTypName: '',
    vehicle_number: '',
    vehicle_type: '',
    ward: '',
    wardId: '',
    wardName: '',
    wip_date: '',
    zone: '',
    zoneId: '',
    zoneName: '',
  }

  partObj = { partsArray: [] }
  partArray = []
  part_Array = []
  maintVehInfo = []
  blankAry = []
  updatePartsObj = {}

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    public router: Router,
    public db: AngularFirestore,
    private vehMaintenanceService: VehMaintenanceService, //service file, just in case
    public afs: AngularFirestore,
  ) {
    this.maintenanceDate = new Date()
    this.newLogarray = []

    this.partList = []
    this.partArray = []

    this.json_part_array = []

    this.buttonDisable = false
    this.vehTypeCheck = true

    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })
    this.allData = this.allData.bind(this)
  }

  //get vehicles Details By Project Id
  getAllVehiclesDetails(status) {
    this.loaderService.display(true)
    this.http
      .get(
        environment.apiUrl +
          'maintenance/getMaintVehDetails?prjid=' +
          this.prjId +
          '&status=' +
          status,
      )
      .subscribe((data) => {
        this.vehMaintenanceList = data

        if (this.vehMaintenanceList.length > 0) {
          this.gridDataVehList = process(this.vehMaintenanceList, this.state)

          this.distinctStatus = distinctStatus(this.vehMaintenanceList)
          this.distinctCat = distinctCat(this.vehMaintenanceList)
          this.distinctType = distinctType(this.vehMaintenanceList)
          this.distinctIMEI = distinctIMEI(this.vehMaintenanceList)
          this.distinctStage = distinctStage(this.vehMaintenanceList)
          this.loaderService.display(false)
        } else {
          this.vehMaintenanceList = []
          this.gridDataVehList = process(this.vehMaintenanceList, this.state)
          this.loaderService.display(false)
        }
        for (var i = 0; i < this.vehMaintenanceList.length; i++) {
          if (this.vehMaintenanceList[i].StatusId == 1) {
            this.statusChsnged = true
          } else {
            this.statusChsnged = false
          }
        }

        this.getStandbyVehicles(this.vehMaintenanceList)
      })
  }

  //To find the Maintenence Status Count details
  getMaintenanceStatusCount() {
    this.http
      .get(
        environment.apiUrl +
          'maintenance/getMaintenanceStatusCount?PRJID=' +
          this.prjId,
      )
      .subscribe((data) => {
        this.maintenanceCount = data
        if (this.maintenanceCount.length > 0) {
          this.totalCount = this.maintenanceCount[0].Total
          this.runningCount = this.maintenanceCount[0].RUNNING
          this.serviceCount = this.maintenanceCount[0].SERVICE
          this.underService = this.maintenanceCount[0].INSERVICE
          this.serviceDone = this.maintenanceCount[0].SERVICEDONE
          this.maintDoneCount = this.maintenanceCount[0].MAINTENANCE
          this.reported = this.maintenanceCount[0].REPORTED
          this.accepted = this.maintenanceCount[0].ACCEPED
          this.progress = this.maintenanceCount[0].PROGRESS_WIP
          this.completed = this.maintenanceCount[0].COMPLETED
          this.standByCount = this.maintenanceCount[0].STANDBY
        }
      })
  }

  getStandbyVehicles(data) {
    this.standbyVeh = data.filter((item) => item.StatusId == 4)
  }

  //to filter the data as per card click
  getStatusData(data) {
    //  console.log(data, "Hi");
    if (data == 'All') {
      this.getAllVehiclesDetails('All')
    } else {
      this.getAllVehiclesDetails(data)
    }
  }

  syncData() {
    this.syncing = true
    this.loaderClass = 'fas fa-sync fa-spin'
    this.getAllVehiclesDetails('All')
    this.getMaintenanceStatusCount()
    this.syncing = false
    this.loaderClass = 'fas fa-sync'
  }

  // to filter the grid data
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state
    this.gridDataVehList = process(this.vehMaintenanceList, this.state)
    if (state && state.group) {
      this.gridDataVehList = process(this.vehMaintenanceList, this.state)
      this.distinctStatus = distinctStatus(this.vehMaintenanceList)
      this.distinctCat = distinctCat(this.vehMaintenanceList)
      this.distinctType = distinctType(this.vehMaintenanceList)
      this.distinctIMEI = distinctIMEI(this.vehMaintenanceList)
      this.distinctStage = distinctStage(this.vehMaintenanceList)
    }
  }

  //To get vehicle info
  getVehicleInfo(data) {
    this.loaderService.display(true)
    this.vehType = data.vehTypName
    this.vtsMobile = data.vtsMobileno
    this.maintStatus = data.maintenanceStatus
    this.currImeiNo = data.imei
    this.parkLoc = data.entityname
    this.chasisNo = data.chasisNo
    this.vtsStatus = data.VTSSTATUS
    this.simNo = data.SIM
    this.dataStatus = data.DataStatus
    this.statusDate = data.STATUSDATE
    var currVehId = data.ID
    this.http
      .get(environment.apiUrl + 'maintenance/getVehicleInfo?ID=' + currVehId)
      .subscribe((data) => {
        this.vehicleInfo = data
        console.log('logDate', this.vehicleInfo)
        this.loaderService.display(false)
      })
    $('#vehicleInfoModal').modal('show')
  }

  viewStatus(data) {
    console.log('vehNo', data)
    this.mntVehId = data.ID
    this.router.navigate(['/home/maintenance/maintenanceStatus', this.mntVehId])
  }
  onChangeSubVeh(data) {
    this.subVehNo = data.vehno
    this.subVehID = data.ID
    this.noSubVeh = false
  }

  // opens breakdown model
  sendTOBreakdown(data) {
    this.clearAllFields()
    this.fbVehNo = data.vehno
    this.fbIMEI = data.imei
    this.fbChasis = data.chasisNo
    this.fbPrjID = data.PRJID.toString()
    this.fbVehID = data.ID.toString()
    this.fbVehTyp = data.vehTypName
    this.fbVehCat = data.vehcatname
    this.fbVehTempNo = data.VEHTEMPNO
    this.statusDated = data.STATUSDATE
    this.vehCurrentStatus = data.StatusId

    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    var charactersLength = characters.length
    this.uniqueID = ''
    for (var i = 0; i < 20; i++) {
      this.uniqueID += characters.charAt(
        Math.floor(Math.random() * charactersLength),
      )
    }
    if (data.VTSSTATUS == 'Yes') {
      this.fbVTSStatus = 'Live'
    } else {
      this.fbVTSStatus = 'Dead'
    }
    $('#breakDownModel').modal('show')

    console.log('558 breakdown')
  }

  onSubmit() {
    console.log(' 585 breakdown')

    // if(this.subVehNo == null || this.subVehNo == 'undefined' || this.subVehNo == ''){
    // 	this.noSubVeh = true
    // 	return false;
    // }

    let dateObj = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')
    var dateString = dateObj.toString()
    // this.VehClass.subVehNo = this.subVehNo
    // this.VehClass.subVehID = this.subVehID
    this.VehClass.Status = 'BREAKDOWN'
    this.VehClass.CurrStatus = this.vehCurrentStatus
    this.VehClass.refid = this.uniqueID
    this.VehClass.push_id = this.uniqueID
    this.VehClass.VTSStatus = this.fbVTSStatus
    this.VehClass.chasisNo = this.fbChasis
    this.VehClass.imei = this.fbIMEI
    this.VehClass.prjid = this.fbPrjID
    this.VehClass.reportedby = this.userName
    this.VehClass.usermobile = this.userMob
    this.VehClass.reported_Date = dateString
    this.VehClass.request_status = 'open'
    this.VehClass.stage = 'REPORTED'
    this.VehClass.statusId = '3'
    this.VehClass.stageID = '1'
    this.VehClass.statusDate = dateString
    this.VehClass.tab_position = '0'
    this.VehClass.vehCatName = this.fbVehCat
    this.VehClass.vehId = this.fbVehID
    this.VehClass.vehTypName = this.fbVehTyp
    this.VehClass.vehicle_number = this.fbVehNo
    this.VehClass.vehTempNo = this.fbVehTempNo
    this.VehClass.isSave = 0
    this.VehClass.driver_name = this.driver_name
    this.VehClass.workShopvalue = this.workShopvalue

    if (this.VehClass.complaint == '' || this.VehClass.complaint == null) {
      alert('Reasoning is Required!')
      $('#complaintBox').css('border', '2px solid red')
      return false
    }
    if (this.driver_name == '' || this.driver_name == null) {
      alert('Driver name is Required!')
      $('#driverBox').css('border', '2px solid red')
      return false
    }
    if (
      this.VehClass.workShopvalue == '' ||
      this.VehClass.workShopvalue == null
    ) {
      alert('Workshop name is Required!')
      $('#driverBox').css('border', '2px solid red')
      return false
    }

    this.insertVehicleMatenanceRecords(this.VehClass)
    this.getAllVehiclesDetails('All')
    this.getMaintenanceStatusCount()
    $('#breakDownModel').modal('hide')
  }

  // opens accepted model
  sendToAccepted(event, data) {
    // this.AvailableDieselAttimeOfEngWorkErrMSG = false ;
    // this.AvailableDieselAttimeOfEngWork  = '';
    this.clearAllFields()
    this.fbVehID = data.ID
    this.fbVehNum = data.vehno
    this.vehType = data.vehTypName
    this.currentStatus = data.maintenanceStatus
    this.currentStatusID = data.StatusId
    this.currentStage = data.STAGENAME
    this.currentStageID = data.MENTSTAGEID
    this.fetchLogData(this.fbVehID, this.currentStageID)
    $('#acceptedModel').modal('show')
  }

  onAccept() {
    if (
      this.AvailableDieselAttimeOfEngWork == null ||
      this.AvailableDieselAttimeOfEngWork == undefined ||
      this.AvailableDieselAttimeOfEngWork == '' ||
      this.AvailableDieselAttimeOfEngWork == 'null'
    ) {
      this.AvailableDieselAttimeOfEngWorkErrMSG = true

      return
    }

    var acceptDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')
    var acceptedDATE = acceptDate.toString()
    var isVendor
    var isMechanics
    var userType
    if (this.isVendorOrMechanic == 1) {
      isVendor = 'false'
      isMechanics = 'true'
      userType = 'Mechanic'
    }
    if (this.isVendorOrMechanic == 2) {
      isVendor = 'true'
      isMechanics = 'false'
      userType = 'Vendor'
    }

    var obj = {
      CurrStatus: this.currentStatusID,
      observation: this.observation,
      reqAction: this.actionrequired,
      vendor: isVendor,
      mec: isMechanics,
      userType: userType,
      mecName: this.mecName,
      mecMobile: this.mecMobile,
      acceptedDATE: acceptedDATE,
      actionRequired: this.actionrequired,
      vehid: this.fbVehID,
      vehNum: this.fbVehNum,
      status: this.currentStatus,
      stageId: this.currentStageID,
      request_status: 'open',
      Status: 'BREAKDOWN',
      currStage: 'REPORTED',
      prjid: this.prjId,
      accepted_by: this.userName,
      AvailableDieselAtEntry: this.AvailableDieselAttimeOfEngWork,
    }

    console.log(obj)

    this.insertVehicleMatenanceRecords(obj)

    this.getAllVehiclesDetails('All')
    this.getMaintenanceStatusCount()
    $('#acceptedModel').modal('hide')
  }

  // opens wip model
  sendToWIP(event, data) {
    this.values = null

    this.partList.length = 0
    this.partArray.length = 0
    this.sumVal = ''
    this.totalSum = ''
    this.json_part_array.length = 0

    this.clearAllFields()
    this.fbVehID = data.ID
    this.wipVehNo = data.vehno
    this.vehCurrentStatusID = data.StatusId
    this.vehCurrentStageID = data.MENTSTAGEID

    this.vehCurrentStageName = data.STAGENAME
    this.fetchLogData(this.fbVehID, this.vehCurrentStageID)
    $('#wipModel').modal('show')
  }

  returnFalse() {
    return false
  }

  searchParts(event: any) {
    // without type info

    this.values = event.target.value

    console.log('search value ', this.values.length)

    if (this.values.length > 0) {
      this.http
        .get(
          environment.apiUrl +
            'maintenance/searchPartMaster?prjId=' +
            this.prjId +
            '&search=' +
            this.values,
        )
        .subscribe((data) => {
          this.partList = data

          console.log('691', this.partList)

          if (this.partList.length) {
            this.BDPartNumber = this.partList[0].PARTID
            var partqty = this.partList[0].availableQuantity
            this.BDQuantity = partqty.toString()
            this.partQuantity = partqty
            var partrate = this.partList[0].UNITPRICE
            this.BDpartRate = partrate.toString()
            var totalamt = partqty * partrate
            this.totalAmount = totalamt.toString()
          }
        })
    } else {
      this.partList.length = 0
    }
  }

  assignPart(data) {
    this.clearPartData()
    this.partID = data.PARTID
    this.partName = data.PARTNAME
    this.avlblQty = data.availableQuantity
    this.actualQTY = data.availableQuantity
    this.unitPrice = data.UNITPRICE
  }

  checkQtyLmt(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    const numQty = parseInt(filterValue, 10)
    if (numQty > this.actualQTY) {
      //   alert("The quantity has exceeded the available stock. Please change the quantity.")
      $('#qtyBox').css('border', '1px solid red')
      this.hasRightQty = false
      this.hasBiggerQty = true
      this.wrongQty = true
      //   return;
    }
    if (numQty <= this.actualQTY) {
      //   alert("The quantity has exceeded the available stock. Please change the quantity.")
      $('#qtyBox').css('border', '1px solid green')
      this.hasRightQty = true
      this.hasBiggerQty = false
      this.wrongQty = false
      //   return;
    }
  }

  clearPartData() {
    this.partID = null
    this.partName = null
    this.avlblQty = null
    this.unitPrice = null
    this.actualQTY = null
  }

  addPart() {
    var partsObj = {
      //to display the partlist on frontend
      PARTID: this.partID,
      PARTNAME: this.partName,
      UNITPRICE: this.unitPrice,
      availableQuantity: this.avlblQty,
      sumAmnt: this.unitPrice * this.avlblQty,
    }

    var part_number = parseInt(this.partID, 10)
    var part_price = parseInt(this.unitPrice, 10)

    var parts_obj = {
      //to send the array of parts in firebase
      part_number: part_number,
      part_name: this.partName,
      rate: part_price,
      quantity: this.avlblQty,
      amount: this.avlblQty * part_price,
    }

    var partid = parseInt(this.partID, 10)

    this.updatePartsObj = {
      //to update the quantity in inventory
      partId: partid,
      quantity: this.avlblQty,
    }
    this.partObj.partsArray.push(this.updatePartsObj)

    this.partArray.push(partsObj) //for list on frontend
    this.sumVal = this.partArray
      .map((item) => item.sumAmnt)
      .reduce((prev, curr) => prev + curr, 0)
    this.part_Array.push(parts_obj)
    console.log('Parts_array', this.part_Array) //for table of firebase maintenance table
    this.clearPartData()

    this.totalSum = this.sumVal
  }

  removePart(data) {
    var removeIndex = this.partArray
      .map(function (item) {
        // get index of object with PARTID
        return item.PARTID
      })
      .indexOf(data.PARTID)

    // remove object
    this.partArray.splice(removeIndex, 1) //for frontend

    this.partObj.partsArray.splice(removeIndex, 1) //for part update

    this.part_Array.splice(removeIndex, 1) //for firebase

    console.log('remove', this.part_Array)
    console.log('remove', this.partObj)

    this.sumVal = this.partArray
      .map((item) => item.sumAmnt)
      .reduce((prev, curr) => prev + curr, 0)

    this.totalSum = this.sumVal
  }

  addExtra() {
    // this.extraCostView = this.extraCost
    if (this.extraCost) {
      if (
        this.RepairCostRemarks == '' ||
        this.RepairCostRemarks == null ||
        this.RepairCostRemarks == undefined
      ) {
        alert('Please fill the extra cost details in remarks box!')
        $('#extraBox').css('border', '2px solid red')
      }
    }
    if (this.sumVal) {
      this.totalSum = this.sumVal + this.extraCost
    } else {
      this.totalSum = this.extraCost
    }
    console.log('Test', this.partObj.partsArray.length)
  }

  clearExtra() {
    // this.extraCostView = 0
    this.totalSum = this.totalSum - this.extraCost
    this.extraCost = 0
  }

  onWIP() {
    //console.log('Adddetails');

    var partArray = JSON.stringify(this.blankAry)
    var partArrayStr = JSON.stringify(this.part_Array)

    var sumRoundOff
    var extraRoundOff
    if (
      this.totalSum == undefined ||
      this.totalSum == null ||
      this.totalSum == ''
    ) {
      sumRoundOff = 0
    } else {
      var sumRoundOff = this.totalSum.toFixed(0)
    }

    if (
      this.extraCost == undefined ||
      this.extraCost == null ||
      this.extraCost == ''
    ) {
      extraRoundOff = 0
    } else {
      var extraRoundOff = this.extraCost.toFixed(0)
    }

    var totalSum = sumRoundOff.toString()
    var wipDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')
    var workinpDATE = wipDate.toString()

    if (this.partObj.partsArray.length > 0) {
      this.json_part_array = partArrayStr
    } else {
      this.json_part_array = partArray
    }

    let years = moment().format('YYYY')
    let months = moment().format('MM')

    var obj = {
      vehid: this.fbVehID,
      vehNum: this.wipVehNo,
      request_status: 'open',
      stageId: 2,
      currStage: 'ACCEPTED',
      CurrStatus: 3,
      prjid: this.prjId,
      wipDATE: workinpDATE,
      extraCost: extraRoundOff ? extraRoundOff : 0,
      total_amount: totalSum ? totalSum : 0,
      RepairCostRemarks: this.RepairCostRemarks ? this.RepairCostRemarks : '',
      jsonPartArray: this.json_part_array,
      wip_by: this.userName,
      JobCard: 'JCN-' + years + months + '-' + this.JobCardNumber,
      IssueSlip: 'ISN-' + years + months + '-' + this.IssueSlipNumber,
    }

    console.log('985', obj)

    this.insertVehicleMatenanceRecords(obj)

    var arrayObj = { partsArray: [] }

    // if (this.partObj.partsArray.length > 0) {
    // 	this.http.post(environment.apiUrl + 'maintenance/updatePartQuantity', this.partObj).subscribe((data) => {
    // 		console.log('Count', this.partObj);
    // 	});
    // } else {
    // 	this.http.post(environment.apiUrl + 'maintenance/updatePartQuantity', arrayObj).subscribe((data) => {
    // 		console.log('Count', arrayObj);
    // 	});
    // }

    this.getAllVehiclesDetails('All')
    this.getMaintenanceStatusCount()
    $('#wipModel').modal('hide')
  }

  //
  AddDetails() {
    //console.log('Adddetails');

    var partArray = JSON.stringify(this.blankAry)
    var partArrayStr = JSON.stringify(this.part_Array)

    var sumRoundOff
    var extraRoundOff
    if (
      this.totalSum == undefined ||
      this.totalSum == null ||
      this.totalSum == ''
    ) {
      sumRoundOff = 0
    } else {
      var sumRoundOff = this.totalSum.toFixed(0)
    }

    if (
      this.extraCost == undefined ||
      this.extraCost == null ||
      this.extraCost == ''
    ) {
      extraRoundOff = 0
    } else {
      var extraRoundOff = this.extraCost.toFixed(0)
    }

    var totalSum = sumRoundOff.toString()
    var wipDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')
    var workinpDATE = wipDate.toString()

    if (this.partObj.partsArray.length > 0) {
      this.json_part_array = partArrayStr
    } else {
      this.json_part_array = partArray
    }

    let years = moment().format('YYYY')
    let months = moment().format('MM')

    var obj = {
      // to find the row
      vehid: this.fbVehID,
      vehNum: this.wipVehNo,
      request_status: 'open',
      stageId: 3,
      currStage: 'WIP',
      CurrStatus: 3,
      prjid: this.prjId,

      // data to save/update
      wipDATE: workinpDATE,
      extraCost: extraRoundOff ? extraRoundOff : 0,
      total_amount: totalSum ? totalSum : 0,
      RepairCostRemarks: this.RepairCostRemarks ? this.RepairCostRemarks : '',
      jsonPartArray: this.json_part_array,
      wip_by: this.userName,
      IssueSlip: 'ISN-' + years + months + '-' + this.IssueSlipNumber,
    }

    this.http
      .post(environment.apiUrl + 'maintenance/addDetailslog', obj)
      .subscribe((data) => {
        JSON.parse(this.json_part_array)
        this.part_Array = []
        this.blankAry = []
        this.json_part_array = []

        console.log('1061', this.json_part_array)
      })

    //this.insertVehicleMatenanceRecords(obj);
    // console.log(obj)

    // var arrayObj = { partsArray: [] }

    // if (this.partObj.partsArray.length > 0) {
    // 	this.http.post(environment.apiUrl + 'maintenance/updatePartQuantity', this.partObj).subscribe((data) => {
    // 		console.log('Count', this.partObj);
    // 	});
    // } else {
    // 	this.http.post(environment.apiUrl + 'maintenance/updatePartQuantity', arrayObj).subscribe((data) => {
    // 		console.log('Count', arrayObj);
    // 	});
    // }

    this.getAllVehiclesDetails('All')
    //this.getMaintenanceStatusCount()
    $('#wipModel').modal('hide')
  }

  //

  // opens completed model
  sendToComplete(event, data) {
    this.vehTypeCheck = true

    console.log('1037', data['vehTypName'])

    if (data['vehTypName'] == 'Manual Trolly') {
      this.vehTypeCheck = false
    }

    this.AvailableDieselAtExit = ''
    this.AvailableDieselAtExiterrMsg = false
    this.drumIdvalueerrmsg = false
    this.newLogarray = []
    this.partname = ''
    this.ReceivedOil = ''
    this.IssuedOil = ''
    this.IssuedOilErrmsg = false
    this.ReceivedOilErrmsg = false

    this.drumIdvalue = ''

    this.refid = ''
    this.clearAllFields()
    this.completeVehNo = data.vehno
    this.fbVehID = data.ID
    this.vehCurrentStatusID = data.StatusId
    this.vehCurrentStageID = data.MENTSTAGEID
    this.fetchLogData(this.fbVehID, this.vehCurrentStageID)

    setTimeout(() => {
      this.sumValOnComplete = this.logArray
        .map((item) => item.amount)
        .reduce((prev, curr) => prev + curr, 0)
    }, 2000)

    $('#completeModel').modal('show')
  }

  onComplete() {
    if ((this.vehTypeCheck = false)) {
      if (
        this.AvailableDieselAtExit == null ||
        this.AvailableDieselAtExit == undefined ||
        this.AvailableDieselAtExit == '' ||
        this.AvailableDieselAtExit == 'null'
      ) {
        this.AvailableDieselAtExiterrMsg = true
        return
      }
    }

    if (this.partname == 'Engine Oil') {
      if (
        this.ReceivedOil == null ||
        this.ReceivedOil == undefined ||
        this.ReceivedOil == '' ||
        this.ReceivedOil == 'null'
      ) {
        this.ReceivedOilErrmsg = true
        return
      }

      if (
        this.IssuedOil == null ||
        this.IssuedOil == undefined ||
        this.IssuedOil == '' ||
        this.IssuedOil == 'null'
      ) {
        this.IssuedOilErrmsg = true
        return
      }

      if (
        this.drumIdvalue == null ||
        this.drumIdvalue == undefined ||
        this.drumIdvalue == '' ||
        this.drumIdvalue == 'null'
      ) {
        this.drumIdvalueerrmsg = true
        return
      }
      if (this.compairqtyErrMsg == true) {
        return
      }
    }

    var completedDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')
    var completeDATE = completedDate.toString()

    var obj = {
      //to find the row
      vehid: this.fbVehID,
      vehNum: this.completeVehNo,
      request_status: 'open',
      stageId: 3,
      currStage: 'WIP',
      CurrStatus: 3,
      prjid: this.prjId,

      //data to save/update
      completedDATE: completeDATE,
      completed_by: this.userName,

      newLogarray: this.newLogarray,
      logArray: this.logArray,
      ReceivedOil: this.ReceivedOil,
      IssuedOil: this.IssuedOil,
      refid: this.refid,
      AvailableDieselAtExit: this.AvailableDieselAtExit,

      drumIdvalue: this.drumIdvalue,
    }
    console.log('1191', obj)
    this.insertVehicleMatenanceRecords(obj)

    this.getAllVehiclesDetails('All')
    this.getMaintenanceStatusCount()
    $('#completeModel').modal('hide')
  }

  //  check box start

  async ApprovalStatus() {
    this.buttonDisable = true

    this.loaderService.display(true)

    // var checkVtsStatus =   await this.getcheckVtsStopsdata(this.IMEI)

    var checkVtsStatus = true

    console.log('1271', checkVtsStatus)

    if (checkVtsStatus) {
      console.log('1276', checkVtsStatus)
      this.changeStatus()
      this.inesetintoMaintenanceApprovalList('COMPLETE')
    } else {
      this.inesetintoMaintenanceApprovalList('PENDING')
    }
  }

  changeSelection(id) {
    if (this.newLogarray.length > 0) {
      this.selectedItemsList = this.newLogarray.includes(id)

      if (!this.selectedItemsList) {
        this.newLogarray.push(id)
      } else {
        const index = this.newLogarray.indexOf(id)
        if (index > -1) {
          this.newLogarray.splice(index, 1) // 2nd parameter means remove one item only
        }
      }
    } else {
      this.newLogarray.push(id)
    }

    console.log(this.newLogarray)
  }

  //    check box end

  addSubstitute(data) {
    this.completeVehNo = data.vehno
    this.fbVehID = data.ID
    this.vehCurrentStatusID = data.StatusId
    this.vehCurrentStageID = data.MENTSTAGEID
    this.fetchLogData(this.fbVehID, this.vehCurrentStageID)
    console.log(data)
    $('#addSubstituteModal').modal('show')
  }

  saveSubstitute() {
    if (
      this.subVehNo == null ||
      this.subVehNo == 'undefined' ||
      this.subVehNo == ''
    ) {
      this.noSubVeh = true
      return false
    }

    var subData = {
      brokenVehID: this.fbVehID,
      subVehID: this.subVehID,
    }
    console.log(subData)

    this.http
      .post(environment.apiUrl + 'maintenance/addSubstitute', subData)
      .subscribe((data) => {
        var addSub: any
        addSub = data[0]
        this.successMsg = data[0].msg
        if (addSub.status == 200) {
          this.getAllVehiclesDetails('All')
          this.getMaintenanceStatusCount()
          this.success = true
          this.clearFields()
          setTimeout(() => {
            $('#addSubstituteModal').modal('hide')
            this.success = false
          }, 2000)
        } else {
          this.error = true
        }
      })
  }

  //change status to standby
  changeStatusModal(data) {
    console.log('1408', data)

    this.buttonDisable = false

    if (
      data.maintenanceStatus == 'STANDBY' ||
      data.maintenanceStatus == 'RUNNING'
    ) {
      this.newchangeStatus(data)

      return
    }

    this.loaderService.display(true)

    this.isChecked1error = false
    this.isChecked1 = undefined
    this.isChecked2 = undefined
    this.isChecked3 = undefined
    this.mentStageList = null
    this.maintStatusId = data.StatusId
    this.success = false
    this.error = false
    this.vehId = data.ID
    this.maintenStatusid = data.MENTSTAGEID
    this.vehNo = data.vehno
    this.imeiNo = data.imei
    this.maintStatusCheck = data.StatusId
    this.currStatus = data.maintenanceStatus
    this.currStage = data.STAGENAME

    this.IMEI = data.imei

    // this.fetchLogData(this.vehId,this.maintenStatusid);

    this.getRunningMaintenanceId(this.vehId)

    if (this.currStatus == 'RUNNING' && this.currStage == null) {
      this.newStatusID = 4
      this.statusName = 'STANDBY'
    } else if (
      (this.currStatus == 'BREAKDOWN' && this.currStage == 'COMPLETED') ||
      (this.currStatus == 'STANDBY' && this.currStage == null)
    ) {
      this.newStatusID = 1
      this.statusName = 'RUNNING'
    } else {
      return false
    }

    this.getSubID()
  }

  getRunningMaintenanceId(ID) {
    this.http
      .get(
        environment.apiUrl + 'maintenance/getRunningMaintenanceId?vehid=' + ID,
      )
      .subscribe((data) => {
        this.refid = data['refid']

        console.log('1461', data)

        this.checkliststatus = data['checklistDetails']

        //this.tempStatus = data['tempStatus']

        console.log('this.tempStatus', this.tempStatus)

        $('#changeStatusModal').modal('show')

        this.loaderService.display(false)
      })
  }

  changeStatus() {
    console.log('CHECK FUNCTION 1475')

    if (this.newStatusID == 4) {
      this.putOnStandby_by = this.userName
      this.putOnRunning_by = ''
    } else {
      this.putOnRunning_by = this.userName
      this.putOnStandby_by = ''
    }
    var maintenanceData = {
      VEHID: this.vehId,
      maintStatusID: this.newStatusID,
      PRJID: this.prjId,
      ID: this.vehId,
      REAMRKS: this.remarkeModal ? this.remarkeModal : null,
      STATUSDATE: this.maintenanceDate,
      USERID: this.userId,
      IMEI: this.imeiNo,
      STAGEID: 0,
      sub_vehicle_id: this.subVehID,
      putOnRunning_by: this.putOnRunning_by,
      putOnStandby_by: this.putOnStandby_by,
    }
    this.http
      .post(
        environment.apiUrl + 'maintenance/changemaintStatus',
        maintenanceData,
      )
      .subscribe((data) => {
        var updateStatus: any
        updateStatus = data
        if (updateStatus.status == 'ok') {
          this.getAllVehiclesDetails('All')
          this.getMaintenanceStatusCount()
          this.success = true
          this.clearFields()
          setTimeout(() => {
            $('#changeStatusModal').modal('hide')
            $('#defaultchangeStatusModal').modal('hide')
            this.success = false
          }, 2000)
        } else {
          this.error = true
        }
      })
  }

  newchangeStatus(data) {
    this.mentStageList = null
    this.maintStatusId = data.StatusId
    this.success = false
    this.error = false
    this.vehId = data.ID
    this.maintenStatusid = data.MENTSTAGEID
    this.vehNo = data.vehno
    this.imeiNo = data.imei
    this.maintStatusCheck = data.StatusId
    this.currStatus = data.maintenanceStatus
    this.currStage = data.STAGENAME

    if (this.currStatus == 'RUNNING' && this.currStage == null) {
      this.newStatusID = 4
      this.statusName = 'STANDBY'
    } else if (
      (this.currStatus == 'BREAKDOWN' && this.currStage == 'COMPLETED') ||
      (this.currStatus == 'STANDBY' && this.currStage == null)
    ) {
      this.newStatusID = 1
      this.statusName = 'RUNNING'
    } else {
      return false
    }

    this.getSubID()

    $('#defaultchangeStatusModal').modal('show')
  }

  // subveh
  getSubID() {
    this.http
      .get(environment.apiUrl + 'maintenance/getSubVeh?vehid=' + this.vehId)
      .subscribe((data) => {
        this.subVehID = data[0].sub_vehicle_id
        this.isSubstitute = data[0].isSubstitute
      })
  }

  //Clear the Fileds
  clearFields() {
    this.maintStatusModal = null
    this.remarkeModal = null
    this.driverModal = null
    this.stageModel = null
    this.stageId = 0
  }

  // new method for inserting and updating vehicle maintenance log processes
  insertVehicleMatenanceRecords(data) {
    console.log('1302', data)

    this.http
      .post(environment.apiUrl + 'maintenance/createMaintenanceEntry', data)
      .subscribe((res) => {
        let result = res

        JSON.parse(this.json_part_array)
        this.part_Array = []
        this.blankAry = []
        this.json_part_array = []

        console.log(result[0].message)
        if (result[0].success_code == 200) {
          var msg = result[0].message
          Swal({
            type: 'success',
            title: 'Success',
            text: msg,
          })
          return
        } else if (result[0].error_code == 300) {
          var msg = result[0].message
          Swal({
            type: 'error',
            title: 'Opps...',
            text: msg,
          })
          return false
        }
      })
  }

  fetchLogData(vehid, stageid) {
    console.log('ftch logo', stageid)

    this.EngineOilCheck = false

    this.http
      .get(
        environment.apiUrl +
          'maintenance/fetchLogData?prjId=' +
          this.prjId +
          '&vehid=' +
          vehid +
          '&stageid=' +
          stageid,
      )
      .subscribe((data) => {
        this.logData = data[0]
        this.refid = data[0].refid

        //this.getMaintenancePartlogdata(this.refid)

        if (stageid == 3) {
          // this.logArray = JSON.parse(data[0].json_part_array);

          this.getMaintenancePartlogdata(this.refid)
        }
        console.log('1434', this.logData)
      })
  }

  clearAllFields() {
    // breakdown
    this.subVehID = null
    this.subVehNo = null
    this.VehClass.subVehNo = null
    this.VehClass.subVehID = null
    this.fbVehNo = null
    this.fbIMEI = null
    this.fbChasis = null
    this.fbPrjID = null
    this.fbVehID = null
    this.fbVehTyp = null
    this.fbVehCat = null
    this.fbVehTempNo = null
    this.statusDated = null
    this.fbVTSStatus = null
    this.fbVehNum = null
    this.vehType = null
    this.currentStatus = null
    this.currentStage = null
    this.wipVehNo = null
    this.completeVehNo = null

    this.VehClass.complaint = null
    this.observation = null
    this.actionrequired = null
    this.mecName = null
    this.mecMobile = null
    this.driver_name = null

    this.workShopvalue = null
    // this.searchParts = null
    // this.partList = null
    // this.partName = null
    // this.avlblQty = null
    // this.partArray = null
    // this.sumVal = null
    // this.extraCost = null
    // this.RepairCostRemarks = null
    // this.totalSum = null
    // this.maintVehInfo = null
    // this.sumValOnComplete = null
    // this.remarks = null
    // this.cost = null
    // this.totalSumAmount = null

    this.categoryModal = null
    this.partModal = null
    this.quantityModal = null
    this.subCategoryModal = null
    this.typeModal = null
    this.uomModal = null
    this.priceModal = null
  }

  downloadExcelFile(vehicleInfoData) {
    const ws_name = 'VehicleInfo'
    const wb: WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = utils.json_to_sheet(vehicleInfoData)
    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' })
    saveAs(
      new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      'VehicleInfo.xlsx',
    )
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff
    }
    return buf
  }

  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    this.userName = this.auth.getAuthentication().userName
    this.userMob = this.auth.getAuthentication().mobileNo
    this.getAllVehiclesDetails('All')
    this.getMaintenanceStatusCount()

    this.getAllDrumlist()

    //   count data

    //this.getpartMasterData();
  }

  // count data

  /*
    part master data 
  */
  // getpartMasterData() {
  // 	this.http.get(environment.apiUrl + 'maintenance/getpartMasterData').subscribe(data => {

  // 	var masterdata  = data ;

  // 	console.log('1229',masterdata[1]);
  // 	   var arrdata = masterdata[1].json_part_array;
  //         var fdata = JSON.parse(arrdata)

  // 	   console.log('1233',fdata[0]);

  // 	});
  //   }

  checkCheckBoxvalue(e, parts) {
    console.log('1406', parts)

    console.log('1405', e.source.value)
  }

  getAllDrumlist() {
    this.http
      .get(environment.apiUrl + 'maintenance/getAllDrumlist')
      .subscribe((data) => {
        this.drumIdList = data

        //console.log('1555',this.drumIdList);
      })
  }

  onDrumIdcahnge() {
    console.log('1091', this.drumIdvalue)

    this.compairqtyErrMsg = false

    for (var i = 0; i < this.drumIdList.length; i++) {
      //console.log(myarray[i].Id)

      if (this.drumIdList[i].Id == this.drumIdvalue) {
        this.compairqty = this.drumIdList[i].Qty
      }
    }

    if (this.IssuedOil > this.compairqty) {
      this.compairqtyErrMsg = true

      return false
    }
  }

  IssuedValueChange() {
    this.drumIdvalue = ''
  }

  getMaintenancePartlogdata(mainId) {
    this.http
      .get(
        environment.apiUrl +
          'maintenance/maintenancePartsList?MaintenanceRefid=' +
          mainId,
      )
      .subscribe((data) => {
        this.logArray = data

        console.log('1637', data)

        for (let index = 0; index < this.logArray.length; index++) {
          this.partname = this.logArray[index].part_name

          if (this.partname == 'Engine Oil') {
            this.EngineOilCheck = true
          }
        }
      })
  }

  //    maintenance Reports All

  // downloadExcelFile(vehicleInfoData) {
  // 	const ws_name = 'VehicleInfo';
  // 	const wb: WorkBook = { SheetNames: [], Sheets: {} };
  // 	const ws: any = utils.json_to_sheet(vehicleInfoData);
  // 	wb.SheetNames.push(ws_name);
  // 	wb.Sheets[ws_name] = ws;
  // 	const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
  // 	saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'VehicleInfo.xlsx');
  // }
  // s2ab(s) {
  // 	const buf = new ArrayBuffer(s.length);
  // 	const view = new Uint8Array(buf);
  // 	for (let i = 0; i !== s.length; ++i) {
  // 		view[i] = s.charCodeAt(i) & 0xff;
  // 	}
  // 	return buf;
  // }

  DownLoadMaintenanceReport() {
    this.loaderService.display(true)
    this.http
      .get(
        environment.apiUrl +
          'maintenance/GetAllMaintenanceData?prjid=' +
          this.prjId,
      )
      .subscribe((data) => {
        console.log('1681', data)

        this.downloadExcelFile(data)
        this.loaderService.display(false)
      })
  }

  async getcheckVtsStopsdata(data) {
    let promise = new Promise((resolve, reject) => {
      this.http
        .get(
          environment.apiUrl +
            'maintenance/getcheckVtsStopsdata?prjid=' +
            this.prjId +
            '&IMEI=' +
            data,
        )
        .subscribe((data) => {
          console.log('1910', data)

          this.stopsValue = data

          if (this.stopsValue.TotalCount > 0) {
            resolve(true)
          } else {
            resolve(false)
            this.isVtsData = true
          }
        })
    })

    return promise
  }

  inesetintoMaintenanceApprovalList(datastatus) {
    var approvalData = {
      refid: this.refid,
      vehno: this.vehNo,
      status: datastatus,
    }

    console.log('approvalData STATUS ', approvalData)

    this.http
      .post(environment.apiUrl + 'maintenance/ApprovalStatus', approvalData)
      .subscribe((data) => {
        this.loaderService.display(false)

        if (datastatus == 'PENDING') {
          this.isChecked1error = false
          this.approvalsuccessMsg = data[0].msg
          this.approvalsuccessMsgcheck = true
          setTimeout(() => {
            $('#changeStatusModal').modal('hide')
            this.approvalsuccessMsg = ''
            this.approvalsuccessMsgcheck = false
          }, 2000)
        }
      })
  }
}

function Swal(arg0: { type: string; title: string; text: any }) {
  throw new Error('Function not implemented.')
}



// WEBPACK FOOTER //
// ./src/app/maintenance/vehicleMaintenance/vehicleMnt/vehicleMaintenance.component.ts